import { DMAPathMap } from './dma-map-constants';

// Module-level promise cache: every DmaMap instance, and anything else that needs DMA names,
// shares one network request.
let dmaPathsPromise: Promise<DMAPathMap> | null = null;

// `??=` won't reassign a rejected promise, so the fetcher below clears the cache on failure —
// that's what lets a retry issue a fresh network request instead of replaying the same rejection.
export const fetchDmaPaths = (): Promise<DMAPathMap> => {
  dmaPathsPromise ??= fetch('https://cdn.blisspointmedia.com/geo/DmaPaths.json')
    .then(r => r.json())
    .catch(e => {
      dmaPathsPromise = null;
      throw e;
    });
  return dmaPathsPromise;
};
